module.exports = __webpack_public_path__ + "img/trama_onboarding_editor.909fec7.svg";